import React from 'react';

export const Label = ({className = '', children, title}) => {
    return (
        <label className={`${className}`} title={title}>
            {children}
        </label>
    )
}